export function hexToRgba(hex: string, alpha: number = 1): string {
  let r: number, g: number, b: number

  // If the hex code starts with '#', remove it
  hex = hex.replace(/^#/, "")

  // Handle 3-digit hex codes like #FFF
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16)
    g = parseInt(hex[1] + hex[1], 16)
    b = parseInt(hex[2] + hex[2], 16)
  }
  // Handle 6-digit hex codes like #FFFFFF
  else if (hex.length === 6) {
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
  } else {
    throw new Error("Invalid hex color.")
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
